import { motion, AnimatePresence } from 'framer-motion'

// Components
import { Link, IconUpArrows } from '@tracklib/kit'
import PlayButton from 'components/playbutton'
import Artists from 'components/track/artists'
import { ButtonMenu } from 'components/track/buttons/buttons'

// Hooks
import { useAudio, useAudioContext } from 'modules/audio/hooks'

// Utils
import { renderTitle } from 'components/player/info'

// Types
import { Song, Track } from 'types'

import styles from './mobilebar.css'

const AnimateOpacity = ({ children, className, initial }: { children: JSX.Element; className?: string; initial?: boolean }) => (
  <motion.div
    className={className}
    key="dots"
    initial={initial === false ? { opacity: 1 } : { opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    {children}
  </motion.div>
)

type MobileBarProps = {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  song: Song
  track: Track
}

const MobileBar = ({ song, track, expanded, setExpanded }: MobileBarProps): JSX.Element => {
  const { songItemId, trackId, loop, contextKey } = useAudio()
  const audioContext = useAudioContext()
  return (
    <div className={styles.wrapper}>
      <AnimatePresence>
        {expanded ? (
          <AnimateOpacity key="expanded" className={styles.expanded}>
            <ButtonMenu trackId={trackId} loop={loop} origin="left" className={styles.dotsButton} />
            {audioContext ? (
              <Link to={audioContext.url} className={styles.context}>
                Playing from <span>{audioContext.title}</span>
              </Link>
            ) : (
              <p className={styles.playingFrom}>Now playing</p>
            )}
            <button onClick={() => setExpanded(!expanded)} className={styles.toggleButtonExpanded}>
              <IconUpArrows />
            </button>
          </AnimateOpacity>
        ) : (
          <AnimateOpacity key="collapsed" className={styles.collapsed} initial={false}>
            <PlayButton
              entity="track"
              value={{ songItemId, trackId, loop }}
              type="bordered"
              contextKey={contextKey}
              hideLoading
              className={styles.playButton}
            />
            <button onClick={() => setExpanded(!expanded)} className={styles.toggleButton}>
              <div>
                <p className={styles.title}>{renderTitle(song, track)}</p>
                <div className={styles.artistName}>
                  <Artists artists={song.artists} genres={song.genres} />
                </div>
              </div>
              <IconUpArrows />
            </button>
          </AnimateOpacity>
        )}
      </AnimatePresence>
    </div>
  )
}

export default MobileBar
